import React, { useMemo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  message,
  Select,
  Space,
  Table,
  Card,
  Row,
  Col,
  Tag,
  Modal,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

// import moment from "moment";
import debounce from "lodash.debounce";

import { useSelector, useDispatch } from "react-redux";
import { productActions } from "../../store";
import categoryApi from "../../api/product/categoryApi";
import productApi from "../../api/product/productApi";

import { LocalImage } from "../../components/ImageUtil";
import { currencyFormat } from "../../utils/index";
import PERMISSION from "../../consts/permissions";

const Product = (props) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const confirm = Modal.confirm;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [listDeleted, setListDeleted] = useState([]);

  const [lstCategory, setLstCategory] = useState([]);

  const [inputFilter, setFilter] = useState({
    keyword: null,
    category: null,
    published: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const { lstProduct, totalCountProducts } = useSelector((x) => x.product);
  const { permissions } = useSelector((x) => x.auth);
  const [listPermissions, setPermissions] = useState(permissions);

  useEffect(() => {
    getProducts();
  }, [inputFilter]);

  useEffect(() => {
    getCategories();
  }, [inputFilter]);

  const getCategories = () => {
    const params = {
      display: true,
      page: 1,
      limit: 1000,
    };
    categoryApi.getCategories(params).then((res, status) => {
      if (res.results) {
        const data = res.results;
        setLstCategory(data);
      }
    });
  };

  const handleSearch = (e) => {
    setFilter({ ...inputFilter,page: 1, keyword: e.target.value });
  };

  const getProductsDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getProducts = () => {
    setLoading(true);
    dispatch(productActions.getProducts(inputFilter)).then(() => {
      setLoading(false);
    });
  };

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      keyword: inputFilter.keyword,
      sortBy: sort,
      category: inputFilter.category,
      published: inputFilter.published,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Ảnh hiển thị",
      dataIndex: "avatar",
      key: "avatar",
      render: (avatar) => (
        <>
          <LocalImage
            src={avatar}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: 250,
      className: "text-center",
    },
    {
      title: "Tên sản phẩm",
      dataIndex: "name",
      render: (text) => <h3>{text}</h3>,
      width: "10%",
    },
    // {
    //   title: "SKU",
    //   dataIndex: "sku",
    //   render: (text) => <label>{text}</label>,
    //   width: "5%",
    //   className: "text-center",
    // },

    {
      title: "Danh mục",
      dataIndex: "category",
      render: (category) => <label>{category?.name}</label>,
      width: "15%",
    },
    {
      title: "Giá thực",
      dataIndex: "originalPrice",
      render: (text) => <label>{currencyFormat(text)}</label>,
      width: "10%",
      className: "text-center",
    },
    {
      title: "Giá bán",
      dataIndex: "price",
      render: (text) => <label>{currencyFormat(text)}</label>,
      width: "10%",
      className: "text-center",
    },
    {
      title: "Giá khuyến mãi",
      dataIndex: "salePrice",
      render: (text) => <label>{currencyFormat(text)}</label>,
      width: "10%",
      className: "text-center",
    },

    {
      title: "Số lượng",
      dataIndex: "quantity",
      render: (text) => <label>{text}</label>,
      width: "5%",
      className: "text-center",
    },
    {
      title: "Trạng thái",
      dataIndex: "published",
      render: (display) => (
        <>
          {display === true && (
            <Tag color="green" key={display}>
              Hoạt động
            </Tag>
          )}
          {display === false && (
            <Tag color="red" key={display}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
      className: "text-center",
      width: 50,
    },
    // {
    //   title: "Hiển thị trang chủ",
    //   dataIndex: "displayHome",
    //   render: (displayHome) => (
    //     <>
    //       {displayHome === true && (
    //         <Tag color="green" key={displayHome}>
    //           Hiển thị
    //         </Tag>
    //       )}
    //       {displayHome === false && (
    //         <Tag color="red" key={displayHome}>
    //           Không hiển thị
    //         </Tag>
    //       )}
    //     </>
    //   ),
    //   className: "text-center",
    //   width: 50,
    // },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {listPermissions.includes(PERMISSION.Admin_Product_Update) ? (
            <>
              <Link to={`/product/edit/` + record.id}>
                <Button
                  // onClick={() => showEditModal(record)}
                  value="large"
                  icon={<EditOutlined />}
                >
                  Sửa
                </Button>
              </Link>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Product_Delete) ? (
            <>
              <Button
                value="large"
                type="primary"
                icon={<DeleteOutlined />}
                danger
                onClick={() => deleteProduct(record)}
              >
                Xóa
              </Button>
            </>
          ) : null}
        </Space>
      ),
      width: 150,
      className: "text-center",
      // fixed: "right",
    },
  ];

  const deleteProduct = (record) => {
    const data = {
      ids: record.id,
    };
    confirm({
      title: "Bạn có muốn xóa các sản phẩm này không?",
      onOk() {
        productApi
          .deleteProducts(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công sản phẩm ");
              getProducts();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tên hoặc SKU sản phẩm</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                // value={inputFilter.username}
                placeholder="Nhập tên hoặc SKU sản phẩm..."
                onChange={getProductsDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6}>
              <label className="">Danh mục</label>
              <Select
                defaultValue={inputFilter.category}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1,category: e });
                }}
              >
                <Option value="">---Mặc định---</Option>
                {lstCategory == null ||
                lstCategory === "undefined" ||
                lstCategory === []
                  ? []
                  : lstCategory.map((item, key) => (
                      <Option key={key} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
              </Select>
            </Col>
            <Col span={6}>
              <label> Published</label>
              <Select
                value={inputFilter.published}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter,page: 1, published: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value="true">Hoạt động</Option>
                <Option value="false">Không hoạt động</Option>
              </Select>
            </Col>
            <Col span={6}></Col>
          </Row>
        </Card>

        <br />
        <Space size={10}>
          {listPermissions.includes(PERMISSION.Admin_Product_Create) ? (
            <>
              <Link to="/product/add">
                <Button type="dashed" size="small">
                  <EditOutlined /> &nbsp; Thêm sản phẩm
                </Button>
              </Link>
            </>
          ) : null}
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstProduct}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCountProducts,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default Product;
